import routesLimited from '@/constants/routesLimited.js'
import { castRouteIds } from 'plugins/router/routes/castRouteIds'
import type { RouteWithParams } from 'plugins/router/types.ts'
import type { RouteRecordRaw } from 'vue-router'
import { aliases } from '../aliases'

const sendGreetingToAllPersons = {
	component: () =>
		import('components/templates/Datatable/Selected/SendGreetingToAll.vue'),
	name: 'sendgreetingtoall',
	path: '/sendgreetingtoall',
	meta: {
		title: 'Zugangsdaten an all versenden',
		auth: true,
		limited: routesLimited.can_update,
		subs: [routesLimited.subMethods.notification_welcome],
	},
}

//MANAGEMENT
const sync = {
	component: () =>
		import('components/modules/Administration/Management/Syncs/Sync.vue'),
	meta: {
		nav: false,
		title: 'Sync',
		validateItem: true,
	},
	alias: aliases.sync_update,
	name: 'sync',
	path: ':id',
	props: castRouteIds,
}
const syncs = {
	children: [sync],
	component: () =>
		import('components/modules/Administration/Management/Syncs/List.vue'),
	name: 'syncs',
	meta: {
		icon: 'fa-fw fa-solid fa-rotate',

		nav: true,
		title: 'entity.sync.name',
	},
	path: 'syncs',
}

const subscriptions = {
	name: 'subscriptions',
	path: '/administration/management/subscriptions',
	meta: {
		title: 'routeTitle.subscriptions',
		icon: 'fa-solid fa-file-signature',
		nav: true,
		limited: routesLimited.isAdminOrTeam,
	},
	component: () =>
		import('components/modules/Administration/Management/Subscriptions/Subscriptions.vue'),
	// children: [],
	props: castRouteIds,
}

const syncFailures = {
	name: 'syncfailures',
	path: 'sync_failures',
	component: () =>
		import('components/modules/Administration/Management/SyncFailures/SyncFailures.vue'),
	meta: {
		icon: 'fa-fw fa-solid fa-triangle-exclamation',
		nav: true,
		title: 'routeTitle.syncFailures',
		subtitle: 'Überblick über die Datenübertragung aus dem ERP-System',
		limited: routesLimited.is_sync_failures,
	},
}

const accessRejections = {
	name: 'personAccessRejections',
	path: 'access-rejections',
	component: () =>
		import('components/modules/Administration/Management/AccessRejections/List.vue'),
	meta: {
		icon: 'fa-fw fa-solid fa-user-lock',
		nav: true,
		title: 'routeTitle.accessRejections',
		subtitle: 'component.accessRejections.subtitle',
		limited: routesLimited.is_access_rejections,
	},
}

const notifications = {
	component: () =>
		import('components/modules/Administration/Management/Notifications.vue'),
	meta: {
		icon: 'fa-fw fas fa-bells',
		nav: true,

		title: 'routeTitle.notifications',
		subs: [routesLimited.subModules.notifications],
	},
	name: 'notifications',
	path: 'notifications',
}
const users = {
	children: [sendGreetingToAllPersons],
	component: () =>
		import('@/components/modules/Administration/Management/Users.vue'),
	meta: {
		icon: 'fa-fw fas fa-users-cog',
		nav: true,

		title: 'entity.user.name',
		subtitle: 'Übersicht über bestehende Zugänge',
	},
	name: 'accounts',
	path: 'accounts',
}
const teamCreate = {
	component: () =>
		import('@/components/modules/Administration/Management/Teams/CreateEdit.vue'),
	name: 'teamCreate',
	path: 'create',
	meta: { title: 'routeTitle.createTeammember' },
}
const teamEdit = {
	component: () =>
		import('@/components/modules/Administration/Management/Teams/CreateEdit.vue'),
	name: 'teamEdit',
	path: ':id',
	meta: {
		title: 'routeTitle.updateTeammember',
		//validateItem: true,
	},
	props: castRouteIds,
}
const team = {
	children: [teamCreate, teamEdit],
	component: () =>
		import('@/components/modules/Administration/Management/Teams/List.vue'),
	meta: {
		icon: 'fa-solid fa-chalkboard-teacher',

		nav: true,
		title: 'common.team',
		subtitle: 'Teammitglieder anlegen / bearbeiten',
	},
	name: 'team',
	path: 'teams',
}

const rolePermission = {
	component: () =>
		import('components/modules/Administration/Management/Roles/Role.vue'),
	name: 'rolepermission',
	path: ':id',
	meta: {
		icon: 'group',
		title: 'routeTitle.roles',
	},
	props: castRouteIds,
}
const rolesPermissions = {
	children: [rolePermission],
	component: () =>
		import('components/modules/Administration/Management/Roles/Roles.vue'),
	meta: {
		icon: '$person_function',

		nav: true,
		title: 'routeTitle.roles',
		subtitle: 'Berechtigungen von Rollen anpassen',
		subs: [routesLimited.subModules.role_permissions],
	},
	name: 'rolepermissions',
	path: 'roles',
}
const usageRate = {
	component: () =>
		import('components/modules/Administration/Management/Usage/Rate.vue'),
	meta: {
		title: 'Tarif',
	},
	name: 'usageStorage',
	path: '',
}
const usageUser = {
	component: () =>
		import('components/modules/Administration/Management/Usage/User.vue'),
	name: 'usageUser',
	path: 'user',
	meta: {
		icon: 'fal fa-users',
		title: 'Benutzer',
	},
}
const usageDocumentType = {
	component: () =>
		import('components/modules/Administration/Management/Usage/DocumentType.vue'),
	meta: {
		title: 'Dokumentenarten',
		subs: [routesLimited.subModules.documents],
	},
	name: 'usageDocumentType',
	path: 'doctypes',
}
const managementUsage = {
	children: [usageRate, usageUser, usageDocumentType],
	component: () =>
		import('components/modules/Administration/Management/Usage/Usage.vue'),
	path: 'usage',
	name: 'usage',
	redirect: { name: 'usageStorage' },
	meta: {
		icon: 'fa-solid fa-chart-line',

		nav: true,
		title: 'routeTitle.analysis',
		subtitle: 'Grafische Auswertung über die Nutzungsstatistiken',
	},
}

const buildingVisibility = {
	name: 'buildingVisibility',
	path: 'building-visibility',
	component: () =>
		import('components/modules/Administration/Management/BuildingVisibility.vue'),
	meta: {
		icon: 'fa-fw fa-solid fa-eye-slash',
		nav: true,
		title: 'routeTitle.buildingVisibility',
		subtitle: 'component.management.buildingVisibility.subtitle',
		limited: routesLimited.is_admin,
		// ERP-Gate: useNavStore().initialise() wertet `hidden` aus und entfernt
		// die Route für Nicht-Karthago-Mandanten komplett – kein Nav-Link UND
		// kein Direktzugriff (nicht nur der Menüeintrag wird ausgeblendet).
		hidden: routesLimited.is_karthago,
	},
}

const management = {
	children: [
		syncs,
		managementUsage,
		notifications,
		users,
		rolesPermissions,
		team,
		subscriptions,
		syncFailures,
		accessRejections,
		buildingVisibility,
	],
	component: () => import('components/modules/PassThrough.vue'),
	meta: {
		auth: true,
		icon: 'fa-fw fas fa-users-cog',

		nav: true,
		title: 'common.management',
	},
	name: 'management',
	path: 'management',
	redirect: { name: 'syncs' },
}
//SETTINGS
const mailDefault = {
	component: () =>
		import('components/modules/Administration/Settings/Mail/Settings.vue'),
	meta: {
		title: 'E-Mail | Einstellungen',
	},
	name: 'mail',
	path: '',
}

const settingsReportStatusEdit = {
	name: 'settingsReportStatusEdit',
	path: ':reportStatusId/edit',
	// path: 'edit',
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportStatusCreateEdit.vue'),
	meta: {
		title: 'routeTitle.updateReportStatus',
		icon: '',

		nav: false,
	},
	props: (route: RouteWithParams) => {
		return {
			reportStatusId: parseInt(route.params.reportStatusId),
			mode: 'edit',
		}
	},
}

const settingsReportStatusCreate = {
	name: 'settingsReportStatusCreate',
	path: 'create',
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportStatusCreateEdit.vue'),
	meta: {
		title: 'routeTitle.createReportStatus',
	},
}
const settingsReportStatus = {
	name: 'settingsReportStatus',
	path: 'status',
	children: [settingsReportStatusCreate, settingsReportStatusEdit],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportStatusList.vue'),
	meta: {
		title: 'entity.reportStatus.name',
	},
}
const reportSubTypeCreate = {
	name: 'reportSubTypeCreate',
	path: 'report_sub_types/create',
	// children: [],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportSubTypeCreateEdit.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'routeTitle.createReporttypeSubcategory',
	},
}
const reportSubTypeEdit = {
	name: 'reportSubTypeEdit',
	path: 'sub_types/:reportSubTypeId/edit',
	// children: [],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportSubTypeCreateEdit.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'routeTitle.updateReporttypeSubcategory',
	},
	props: (route: RouteWithParams) => {
		return {
			reportTypeId: parseInt(route.params.reportSubTypeId),
			mode: 'edit',
		}
	},
}
const reportTypeCreate = {
	name: 'reportTypeCreate',
	path: 'create',
	// children: [],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportTypeCreateEdit.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'routeTitle.createReportType',
	},
}
const reportTypeEdit = {
	name: 'reportTypeEdit',
	path: ':reportTypeId/edit',
	// children: [],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportTypeCreateEdit.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'routeTitle.updateReportType',
	},
	props: (route: RouteWithParams) => {
		return {
			reportTypeId: parseInt(route.params.reportTypeId),
			mode: 'edit',
		}
	},
}
const settingsReportTypes = {
	name: 'settingsReportTypes',
	path: 'types',
	children: [
		reportTypeCreate,
		reportTypeEdit,
		reportSubTypeCreate,
		reportSubTypeEdit,
	],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/ReportTypeList.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'entity.reportType.name',
	},
}

const settingsReport = {
	name: 'settingsReport',
	path: 'report',
	children: [settingsReportTypes, settingsReportStatus],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Report/Tabs.vue'),
	meta: {
		icon: '',

		nav: false,
		title: 'entity.report.name',
	},
}

const mailTemplates = {
	component: () =>
		import('components/modules/Administration/Settings/Mail/Templates.vue'),
	meta: {
		title: 'E-Mail | Vorlagen',
	},
	name: 'mailTemplates',
	path: 'templates',
}
const settingsMail = {
	children: [mailDefault, mailTemplates],
	component: () =>
		import('components/modules/Administration/Settings/Mail/Mail.vue'),
	meta: {
		icon: 'fa-fw far fa-mail-bulk',

		nav: true,
		title: 'common.emails',
		subtitle: 'E-Mail Vorlagen und Einstellungen verwalten',
		subs: [routesLimited.subModules.notifications],
	},
	path: 'mail',
	name: 'settingsMail',
	redirect: { name: 'mail' },
}
const settingsGeneric = {
	component: () =>
		import('components/modules/Administration/Settings/Generic.vue'),
	meta: {
		icon: 'fa-fw far fa-pencil-paintbrush',

		nav: true,
		title: 'common.general',
		subtitle: 'Erscheinungsbild, Farben usw. verwalten',
	},
	name: 'generic',
	path: 'generic',
}
const settingsDocumentType = {
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Documenttypes/Item.vue'),
	name: 'documenttypeedit',
	path: ':id',
	props: castRouteIds,
	meta: {
		subs: [routesLimited.subModules.documents],
	},
}
const handOverTemplateCreate = {
	component: () =>
		import('@/components/modules/Administration/Settings/Definitions/HandoverTemplates/CreateEdit.vue'),
	name: 'handOverTemplateCreate',
	path: 'create',
	meta: { title: 'routeTitle.createHandovertemplate' },
}
const handOverTemplateEdit = {
	component: () =>
		import('@/components/modules/Administration/Settings/Definitions/HandoverTemplates/CreateEdit.vue'),
	name: 'handOverTemplateEdit',
	path: ':id/edit',
	meta: {
		title: 'routeTitle.updateHandovertemplate',
	},
	props: castRouteIds,
}
const settingsHandoverTemplates = {
	component: () =>
		import('components/modules/Administration/Settings/Definitions/HandoverTemplates/List.vue'),
	name: 'handoverTemplates',
	path: '/administration/settings/definitions/handovertemplates',
	meta: {
		icon: 'fa-fw far fa-list',
		nav: false,
		title: 'entity.handoverProtocol.name',
		subs: [routesLimited.subModules.handover_protocols],
	},
	children: [handOverTemplateCreate, handOverTemplateEdit],
}
const settingsDocumentTypes = {
	children: [settingsDocumentType],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Documenttypes/List.vue'),
	meta: {
		icon: 'fa-fw fas fa-book',

		nav: false,
		title: 'routeTitle.documentTypes',
		subs: [routesLimited.subModules.documents],
	},
	name: 'documenttypessettings',
	path: 'documenttypes',
}
const settingsPolicies = {
	component: () =>
		import('components/modules/Administration/Settings/Policies.vue'),
	meta: {
		icon: 'fa-fw fal fa-user-secret',

		nav: true,
		title: 'Bestimmungen',
	},
	name: 'policies',
	path: 'policies',
}
const settingsNoteType = {
	component: () =>
		import('@/components/modules/Administration/Settings/Definitions/Notetypes/CreateEdit.vue'),
	name: 'notetypeedit',
	path: ':id/edit',
	props: castRouteIds,
	meta: { title: 'routeTitle.updateNotesType' },
}
const notetypeCreate = {
	component: () =>
		import('@/components/modules/Administration/Settings/Definitions/Notetypes/CreateEdit.vue'),
	name: 'notetypeCreate',
	path: 'create',
	meta: { title: 'routeTitle.createNotesType' },
}
const settingsNoteTypes = {
	children: [settingsNoteType, notetypeCreate],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Notetypes/List.vue'),
	meta: {
		icon: 'fa-fw fal fa-sticky-note',

		nav: false,
		title: 'routeTitle.notesTypes',
		subs: [routesLimited.subModules.notes],
	},
	name: 'notetypessettings',
	path: 'notetypes',
}
const settingsDefinitions = {
	children: [
		settingsDocumentTypes,
		settingsNoteTypes,
		settingsHandoverTemplates,
		settingsReport,
	],
	component: () =>
		import('components/modules/Administration/Settings/Definitions/Definitions.vue'),
	meta: {
		icon: 'fa-fw fa-regular fa-clipboard-list-check',

		nav: true,
		title: 'routeTitle.definitions',
	},
	name: 'definitions',
	path: 'definitions',
}

const settings = {
	children: [
		settingsGeneric,
		/*settingsPolicies,*/
		settingsMail,
		settingsDefinitions,
	],
	component: () => import('components/modules/PassThrough.vue'),
	meta: {
		auth: true,
		limited: routesLimited.can_settings,
		icon: 'fa fa-fw fas fa-cogs',

		nav: true,
		title: 'common.settings.name',
	},
	name: 'settings',
	path: 'settings',
	redirect: { name: 'generic' },
}
export const administration: RouteRecordRaw = {
	children: <RouteRecordRaw[]>[management, settings],
	component: () => import('components/modules/PassThrough.vue'),
	name: 'administration',
	meta: {
		auth: true,
		limited: routesLimited.can_settings,
		icon: 'fa-fw far fa-tools',

		nav: true,
		ordering: 10,
		title: 'common.administration',
	},
	path: '/administration',
	redirect: { name: 'accounts' },
}

export const administrationRoutes = [
	administration,
	team,
	subscriptions,
	teamEdit,
	teamCreate,
	notetypeCreate,
	mailTemplates,
	settings,
	settingsPolicies,
	settingsDefinitions,
	settingsGeneric,
	settingsMail,
	mailDefault,
	settingsHandoverTemplates,
	settingsNoteTypes,
	settingsDocumentTypes,
	usageDocumentType,
	settingsNoteType,
	managementUsage,
	notifications,
	users,
	rolesPermissions,
	usageUser,
	rolePermission,
	management,
	sendGreetingToAllPersons,
	sync,
	syncs,
	usageRate,
	settingsReportTypes,
]
